/**
 * Образец материала — тот же рисунок штриховки, что и на чертеже,
 * только маленький. Нужен, чтобы материал выбирали глазами, а не по названию.
 * С флагом bearing показывает, как этот материал выглядит у несущей стены.
 */
import { BEARING_HATCH, type WallCatalogItem } from "@/shared/catalog";
import { useId } from "react";

interface Props {
	material: WallCatalogItem;
	/** Показать штриховку несущей стены — красную */
	bearing?: boolean;
	size?: number;
}

export const MaterialSwatch = ({ material, bearing = false, size = 22 }: Props) => {
	const uniqueId = useId();
	const patternId = `swatch-${material.material}-${uniqueId}`;
	const step = material.spacing;
	const background = bearing ? BEARING_HATCH.background : material.background;
	const stroke = bearing ? BEARING_HATCH.stroke : material.stroke;

	return (
		<svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden>
			<defs>
				<pattern
					id={patternId}
					width={step}
					height={step}
					patternUnits="userSpaceOnUse"
					patternTransform={material.angle === null ? undefined : `rotate(${material.angle})`}
				>
					<rect width={step} height={step} fill={background} />
					{material.angle !== null && (
						<line x1={0} y1={0} x2={0} y2={step} stroke={stroke} strokeWidth={0.8} />
					)}
					{material.dots && (
						<circle cx={step / 2} cy={step / 2} r={0.9} fill={stroke} stroke="none" />
					)}
				</pattern>
			</defs>
			<rect
				x={0.5}
				y={0.5}
				width={size - 1}
				height={size - 1}
				rx={3}
				fill={`url(#${patternId})`}
				stroke="#cdd6e2"
			/>
		</svg>
	);
};
